import type { HubEnv } from '@/env/types';

const approverGroups: Partial<Record<HubEnv, string>> = {
  staging: 'hub-elevation-approvers-staging',
  prod: 'hub-elevation-approvers-prod',
};

export function canApproveSelectedEnvironment(groups: ReadonlySet<string>, env: HubEnv): boolean {
  const approverGroup = approverGroups[env];
  return approverGroup !== undefined && groups.has(approverGroup);
}
